var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 61,
    viewBox: "0 0 38 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.17021 0.999908C2.48669 0.999908 1.80316 1.22485 1.28213 1.67409C0.239292 2.57256 0.239292 4.03075 1.28213 4.92922L31.0529 30.598L1.28213 56.2662C0.239292 57.1653 0.239292 58.6228 1.28213 59.522C2.32496 60.4204 4.01546 60.4204 5.0583 59.522L36.7171 32.2259C37.7599 31.3274 37.7599 29.8692 36.7171 28.9708L5.0583 1.67474C4.53726 1.22485 3.85374 0.999908 3.17021 0.999908Z",
    fill: "white",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/right-arrow.893e4f8bbb5496b228b21200b8fe9141.svg";
export { ForwardRef as ReactComponent };